import { busyFiltersFromQuery, busyQuery } from "./busy-times-utils";
import DoorAccess from "./door-access";
import {
  buildQuery,
  doorOption,
  filtersFromQuery,
  summaryQuery,
} from "./door-access-utils";
import tryLoad from "./try-load";

/**
 * Door access: the controller loads everything the visible tab needs, so a
 * filter change is a navigation (`/actions/refresh`) that lands here again.
 * The filters live in the query string: Logs `range, from, to, memberId,
 * memberName, doors, result, unmatched, page`; Busy times `period, from, to,
 * hours, locations, metric`; both `tab`. A Membership list link opens it
 * pre-filtered: ?tab=logs&memberId=&memberName=&range=30d
 */
const DoorAccessController = async ({ api, req, res, load, locals }) => {
  const query = req.query || {};
  const status = await tryLoad(load, "doorAccessStatus");
  const owner = locals.activeUserToRequest || locals.activeUser || {};

  const tab = status.can?.logs && query.tab !== "busy" ? "logs" : "busy";
  const usable = status.connected && !status.forbidden && !status.error;

  let doorOptions = [];
  let filters = null;
  let busyFilters = null;

  if (usable && tab === "logs") {
    const gymDoors = await tryLoad(load, "gymDoors");
    doorOptions = (gymDoors.doors || []).map(doorOption);
    filters = filtersFromQuery(query, doorOptions);
    await Promise.all([
      tryLoad(load, "doorLogs", {
        ...buildQuery(filters, status.timeZone),
        page: filters.page,
      }),
      tryLoad(load, "doorLogsSummary", summaryQuery(filters, status.timeZone)),
    ]);
  } else if (usable) {
    busyFilters = busyFiltersFromQuery(query);
    if (status.lastEventAt) {
      await tryLoad(
        load,
        "doorBusyTimes",
        busyQuery(busyFilters, status.timeZone)
      );
    }
  }

  res.body = (
    <DoorAccess
      key="door-access"
      api={api}
      status={status}
      gymName={owner.businessName || owner.name || ""}
      tab={tab}
      filters={filters}
      busyFilters={busyFilters}
      doorOptions={doorOptions}
    />
  );
};

export default DoorAccessController;
